var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.78,4.92a4.94,4.94,0,0,1-.93,6.36,5.06,5.06,0,0,1-7.41-6.8,5,5,0,0,1,6.63-1.32c-.22.44-.43.62-1,.39a4.19,4.19,0,0,0-4.95,1.3,4.27,4.27,0,1,0,7.62,2.42A3.44,3.44,0,0,0,11.46,6C11.19,5.43,11.36,5.17,11.78,4.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.92,4.34a.83.83,0,0,1-1,.47,2.66,2.66,0,0,0-2.83,1.5A2.72,2.72,0,0,0,8.74,9.92a2.76,2.76,0,0,0,1.45-2.87c-.1-.57-.1-.57.47-1a3.4,3.4,0,0,1-1.13,4.24A3.49,3.49,0,0,1,4.66,5.46,3.38,3.38,0,0,1,8.92,4.34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.46,3l.56.67c-.3.28-.63.55-.93.85C9.91,5.65,8.75,6.85,7.55,8c-.16.16-.49.15-.75.22.07-.26,0-.59.21-.76C8.45,6,9.92,4.51,11.46,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.78,5.61c-.4.37-.74.65-1,1a1.13,1.13,0,0,0-.06,1.67,1.15,1.15,0,0,0,1.72,0l.94-.88h.06A1.9,1.9,0,0,1,7.52,9.41a2,2,0,0,1-2-2A1.88,1.88,0,0,1,7.78,5.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.05dc951b77c38c5562d6ae2c2b2c2019.svg";
export { ForwardRef as ReactComponent };